import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff, Person, Lock } from "@mui/icons-material";
import { toast } from "react-toastify";
import { apiUrl } from "../../comps/apiUrl";
import "./l.css";
const Login = () => {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    document.title = "Rb Hidraulicos - Login";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user.trim() || !pass.trim())
      return toast.warning("Preencha todos os campos");

    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user, pass }),
      });

      const data = await response.json();
      setLoading(false);

      if (response.status === 200) {
        localStorage.setItem("token", data.token);
        window.location = "/";
      } else {
        toast.error(data.error || "Erro ao fazer login");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Erro de conexão");
    }
  };

  return (
    // Wrapper principal com o Background
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // Aqui você define o background (pode ser cor, gradiente ou imagem)
        //background: "linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)",
        background: `url(${`https://rbhidraulicos.com.br/wp-content/uploads/2024/01/fundo-branco-scaled.jpg`}) no-repeat center center / cover`,
        padding: 2,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 400,
          borderRadius: 3,
          textAlign: "center",
          backgroundColor: "rgba(255, 255, 255, 0.95)", // Leve transparência
          backdropFilter: "blur(5px)", // Efeito de desfoque no fundo
        }}
      >
        <Box sx={{ mb: 3 }}>
          {/* Logo ou Título */}
          <Typography
            variant="h4"
            fontWeight="800"
            color="primary"
            gutterBottom
          >
            RB
          </Typography>
          <Typography
            variant="h6"
            color="textSecondary"
            sx={{ letterSpacing: 2 }}
          >
            SISTEMA DE LOCAÇÃO
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Usuário"
            variant="outlined"
            margin="normal"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Person color="action" />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            label="Senha"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            margin="normal"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock color="action" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
            sx={{
              mt: 4,
              mb: 2,
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            {loading ? (
              <CircularProgress size={26} color="inherit" />
            ) : (
              "ACESSAR PAINEL"
            )}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;
